import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {LoginFormNew} from '../components';
import crisLogo from '../../../assets/images/logos/cris-logo-50.png';
import ptiqcsLogo from '../../../assets/images/logos/ptiqcs-logo.png';

class Login extends Component {
	componentDidMount() {
		document.body.classList.add('login-page');
	}

	componentWillUnmount() {
		document.body.classList.remove('login-page');
	}

	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<div className="login-box">
					<div className="login-logo">
						<img src={ptiqcsLogo} alt="PTIQCS" height="60"/>
					</div>
					<LoginFormNew/>
					<div className="login-logo">
						<img src={crisLogo} alt="CRIS" height="40"/>
					</div>
				</div>
			</Fragment>
		);
	}
}

Login.defaultProps = {
	pageTitle: 'Login'
};

Login.propTypes = {
	pageTitle: PropTypes.string
};

export default Login;